export default {
    platforms: [],
    permissions: [],
    workers: [],
    staticMenuLinks: []
}